export default "__VITE_ASSET__BSJC2BKa__"